import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW0D01Component } from './kymw0d01.component';
import { AppCommonsModule } from '../../../commons/app-commons.module';

/**
 * 処理ログ件数表示 モジュール設定クラス
 *
 * @export KYMW0D01Module
 * @class KYMW0D01Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW0D01Component,
  ],
  providers: [
  ],
})
export class KYMW0D01Module {
}
